<template>
  <v-container fluid class="blue darken-4">
    <McSignup />
  </v-container>
</template>

<script>
import McSignup from './McSignup.vue';

export default {

  name: 'RegisterSubmit',
  components: {
    McSignup,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
